import { IconProps } from '../types';

const IcFolder = (props: IconProps) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M62.9333 23.4666V14.9333C62.9333 12.577 61.0229 10.6666 58.6667 10.6666H30.3701C28.7541 10.6666 27.2768 9.75354 26.5536 8.3082L25.712 6.625C24.9888 5.17967 23.5115 4.2666 21.8955 4.2666H5.33332C2.97705 4.2666 1.06665 6.177 1.06665 8.53327V29.8666H61.8667L62.9333 23.4666Z"
      fill="#EBA33B"
    />
    <path
      d="M57.5999 28.8003V17.0669C57.5999 15.8883 56.6452 14.9336 55.4666 14.9336H8.53324C7.35457 14.9336 6.3999 15.8883 6.3999 17.0669V28.8003H57.5999Z"
      fill="white"
    />
    <path
      d="M62.9333 23.4669V55.4669C62.9333 57.8231 61.0229 59.7335 58.6667 59.7335H5.33332C2.97705 59.7335 1.06665 57.8231 1.06665 55.4669V29.8669C1.06665 27.5106 2.97705 25.6002 5.33332 25.6002H33.6299C35.2459 25.6002 36.7232 24.6871 37.4464 23.2418L38.288 21.5586C39.0112 20.1133 40.4885 19.2002 42.1045 19.2002H58.6677C61.024 19.2002 62.9333 21.1106 62.9333 23.4669Z"
      fill="#FDCC43"
    />
  </svg>
);

export default IcFolder;
